$(document).ready(function () {

    $(".swiper-slide .hero").each(function () {

    let $section = $(this);
    let $button = $section.find(".js-play-button");

    // Get the currently visible video
    let video;

    if (window.innerWidth <= 767) {
        video = $section.find("video.mobile").get(0);
    } else {
        video = $section.find("video.desktop").get(0);
    }

    if (!video) return;

    function initVideo() {
        try {
            video.currentTime = 2;
        } catch (e) {
            console.log(e);
        }

        video.play()
            .then(() => {
                $button.addClass("active");
            })
            .catch((err) => {
                console.log("Autoplay blocked:", err);
            });
    }

    // Handle already loaded videos
    if (video.readyState >= 1) {
        initVideo();
    } else {
        video.addEventListener("loadedmetadata", initVideo);
    }

    // Play / Pause button
    $button.off("click.videoControl").on("click.videoControl", function () {

        if (video.paused) {
            video.play()
                .then(() => {
                    $button.addClass("active");
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            video.pause();
            $button.removeClass("active");
        }

    });

});


    // =========================
    // MEGA MENU HOVER (DESKTOP)
    // =========================
    function megaMenuHover() {
        if ($(window).width() > 1024) {
            $('.eq-header__menu-item.js-mega-menu').hover(function () {
                    $(this).addClass('active');
                    $(this).parents('.eq-header').addClass('menu-active');
                },
                function () {
                    $(this).removeClass('active');
                    $(this).parents('.eq-header').removeClass('menu-active');
                }
            );
        }
    }

    megaMenuHover();
    $(window).resize(megaMenuHover);


    // $(".eq-header").css("--total-menu-height", totalMenuHeight + "px");
    $(".eq-header__menu-item").hover(
        function () {
            let megaMenuHeight = $(this).find(".eq-header__mega-menu").outerHeight() || 0;
            let eqHeaderHeight = $(".eq-header").outerHeight() || 0;

            let totalMenuHeight = eqHeaderHeight + megaMenuHeight;

            $(".eq-header").css("--total-menu-height", totalMenuHeight + "px");
        },
        function () {
            // Optional: reset when mouse leaves
            let eqHeaderHeight = $(".eq-header").outerHeight() || 0;

            $(".eq-header").css("--total-menu-height", eqHeaderHeight + "px");
        }
    );
    // ---------------------- // 

    // =========================
    // MOBILE HAMBURGER MENU
    // =========================
    $('.js-header-hamburger').click(function () {
        $(this).toggleClass('active');
        $(this).parents('.eq-header').toggleClass('menu-active');
    });


    // =========================
    // SUB MENU OPEN (MEGA MENU)
    // =========================
    $('.js-mega-menu > .eq-header__link').on('click', function (e) {
        if (window.innerWidth < 1024) {
            e.preventDefault();
            e.stopPropagation();
        }
        // e.preventDefault();
        $(this).parent('.js-mega-menu').closest('.eq-header__nav').addClass('sub-menu-active');
        $(this).parent('.js-mega-menu').find('.eq-header__mega-menu').addClass('active');
    });


    // =========================
    // BACK BUTTON (SUB MENU CLOSE)
    // =========================
    $('.js-back-button').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).closest('.eq-header__nav').removeClass('sub-menu-active');
        $(this).parent('.eq-header__mega-menu').removeClass('active');
    });


    // =========================
    // MEGA MENU ACCORDION
    // =========================
    $('.js-mega-accordian').on('click', function (e) {
        e.preventDefault();

        var $accordion = $(this);
        var megaInnerNav = $accordion.next('.eq-header__mega-subnav');
        var $parentMega = $accordion.closest('.eq-header__mega-menu');

        // close other open accordions inside the same mega menu only
        $parentMega.find('.eq-header__mega-subnav').not(megaInnerNav).slideUp(300);
        megaInnerNav.stop(true, true).slideToggle(300);
        $accordion.toggleClass('active');
        $parentMega.find('.js-mega-accordian').not($accordion).removeClass('active');
    });

    function toggleHeaderDarkClass() {

    const $header = $(".eq-header");

    // Remove class first
    $header.removeClass("header-dark-applay");

    // Find ONLY the current visible slide
    const $visibleSlide = $(".js-home-swiper .swiper-slide-visible")
        .filter(function () {

            // Ignore hidden slides
            return $(this).css("display") !== "none";

        })
        .last();

    // Check if visible slide has dark class
    if ($visibleSlide.hasClass("header-dark")) {

        $header.addClass("header-dark-applay");

    } else {


    }
}

    const jsHomeSwiper = new Swiper(".js-home-swiper", {

        direction: "vertical",
        speed: 500,
        slidesPerView: 1,
        mousewheel: true,
        resistanceRatio: 0,
        watchSlidesProgress: true,

        effect: "creative",

        creativeEffect: {
            prev: {
                translate: [0, "0%", -1],
            },

            next: {
                translate: [0, "100%", 0],
            },
        },

        on: {

            init: function () {
                toggleHeaderDarkClass();
            },

            slideChangeTransitionEnd: function () {
                toggleHeaderDarkClass();
            },

        },

    });

    /* ==========================================================
    PRODUCT GRID
    ========================================================== */

    const productGrid = document.querySelector(".js-product-grid");
    const viewButtons = document.querySelectorAll(".product-view__button");

    let allSwipers = [];

    /* ==========================================================
    INIT SLIDERS
    ========================================================== */

    function initProductSliders() {

        destroyProductSliders();

        document.querySelectorAll(".product-card").forEach((card) => {
            const slideCount = $(card).find('.swiper-slide').length;
            const slider = card.querySelector(".product-card__slider");
            const media = card.querySelector(".product-card__media");
            const nextBtn = card.querySelector(".product-card__arrow--next");
            const prevBtn = card.querySelector(".product-card__arrow--prev");
            const pagination = card.querySelector(".product-card__pagination");

            const swiper = new Swiper(slider, {
                slidesPerView: 1,
                speed: 700,
                loop: false,

                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },

                pagination: {
                    el: pagination,
                    clickable: true,
                },
            });

            if (slideCount > 1) {
                $(media).removeClass('hide-arrow');
            } else {
                $(media).addClass('hide-arrow');
            }
            

            card.addEventListener('mouseenter', () => {

                // Current slide store
                card.dataset.prevIndex = swiper.activeIndex;

                const nextIndex = swiper.activeIndex + 1;

                // Next slide exists?
                if (nextIndex < swiper.slides?.length) {
                    swiper.slideTo(nextIndex, 0);
                }
            });

            card.addEventListener('mouseleave', () => {

                const prevIndex = swiper.activeIndex - 1;
                if (prevIndex >= 0) {
                    swiper.slideTo(prevIndex, 0);
                }
            });


            allSwipers.push(swiper);
        });
    }

    /* ==========================================================
    DESTROY SLIDERS
    ========================================================== */

    function destroyProductSliders() {

    allSwipers.forEach((swiper) => {
        swiper.destroy(true, true);
    });

    allSwipers = [];
    }

    /* ==========================================================
    DEFAULT
    ========================================================== */

    initProductSliders();

    /* ==========================================================
    VIEW SWITCH
    ========================================================== */

    const toggleButton = document.querySelector('.js-view-toggle');

    function updateGridView() {

        const url = new URL(window.location.href);

        const isSecondaryGrid =
            url.searchParams.get('secondaryGrid') === 'true';

        if (isSecondaryGrid) {

            productGrid?.classList?.add('view-6');

            destroyProductSliders();

            if (toggleButton) {
                toggleButton.textContent = 'VIEW BY 3';
            }

        } else {

            productGrid?.classList?.remove('view-6');

            initProductSliders();

            if (toggleButton) {
                toggleButton.textContent = 'VIEW BY 6';
            }
        }
    }

    /* Initial State */
    updateGridView();

    /* Toggle Click */

    toggleButton?.addEventListener('click', () => {

        const url = new URL(window.location.href);

        const isSecondaryGrid =
            url.searchParams.get('secondaryGrid') === 'true';

        if (isSecondaryGrid) {

            url.searchParams.delete('secondaryGrid');

        } else {

            url.searchParams.set(
                'secondaryGrid',
                'true'
            );

        }

        window.history.replaceState(
            {},
            '',
            url.toString()
        );

        updateGridView();

    });
    

    // ==========================================================
    // TOTAL IMAGE COUNT
    // ==========================================================

    const $images = $(".eq-product-banner__image-item");
    const totalImages = $images.length;

    $(".eq-product-banner__total").text(totalImages);

    // ==========================================================
    // MOBILE SWIPER
    // ==========================================================

    let productSwiper = null;

    function initMobileSlider() {

        if ($(window).width() <= 991) {

            if (!productSwiper) {

                productSwiper = new Swiper(".eq-product-banner__images",{
                        slidesPerView: 1,
                        speed: 400,
                        loop: true,
                        pagination: {
                            el: '.swiper-pagination',
                        },

                        on: {
                            slideChange: function () {

                                $(".eq-product-banner__current")
                                    .text(this.realIndex + 1);

                            }
                        }
                    }
                );

            }

        } else {

            if (productSwiper) {

                productSwiper.destroy(true, true);
                productSwiper = null;

            }

        }

    }

    initMobileSlider();

    $(window).on("resize", function () {
        initMobileSlider();
    });


    $(window).on("scroll", function () {

        if ($(window).width() > 991) {

            let activeIndex = 1;

            $images.each(function (index) {

                let rect = this.getBoundingClientRect();

                if (
                    rect.top <= window.innerHeight / 2 &&
                    rect.bottom >= window.innerHeight / 2
                ) {
                    activeIndex = index + 1;
                }

            });

            $(".eq-product-banner__current")
                .text(activeIndex);

        }

    });

    Fancybox.bind("[data-fancybox]", {
        Carousel: {
            Thumbs: {
                type: "classic",
                Carousel: {
                    center: (ref) => {
                        return (
                            !ref.isVertical() || ref.getTotalSlideDim() > ref.getViewportDim()
                        );
                    },
                    vertical: false,
                    breakpoints: {
                        "(min-width: 640px)": {
                            vertical: true,
                        },
                    },
                },
            },
        },
    });


    const recentlyViewedSlider = new Swiper(".eq-recently-viewed__slider", {
        slidesPerView: 1.43,
        spaceBetween: 4,
        navigation: {
            nextEl: ".eq-recently-viewed__arrow--next",
            prevEl: ".eq-recently-viewed__arrow--prev",
        },

        breakpoints: {

            576: {
                slidesPerView: 1.6,
            },

            768: {
                slidesPerView: 3,
            },

            1200: {
                slidesPerView: 3,
            }
        }
    });

    const tabButtons = document.querySelectorAll(".legal-page__menu-link");
    const tabPanels = document.querySelectorAll(".legal-page__panel");

    tabButtons.forEach(button => {

        button.addEventListener("click", () => {

            const tabId = button.dataset.tab;

            tabButtons.forEach(btn => {
                btn.classList.remove("is-active");
            });

            tabPanels.forEach(panel => {
                panel.classList.remove("is-active");
            });

            button.classList.add("is-active");

            document
                .getElementById(tabId)
                .classList.add("is-active");
        });

    });

    $(".eq-header__search").on("click", function () {
        $(".search-overlay").addClass("active");
        $("body").addClass("search-overlay-active");
        $("body").css("overflow", "hidden");
    });

    $(".search-close").on("click", function () {
        $(".search-overlay").removeClass("active");
        $("body").removeClass("search-overlay-active");
        $("body").css("overflow", "");
    });

    const searchProductsSlider = new Swiper(".search-products-slider", {
        slidesPerView: 4,
        spaceBetween: 4,
        speed: 400,

        navigation: {
            nextEl: ".search-products-next",
            prevEl: ".search-products-prev",
        },

        breakpoints: {
            0: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 2
            },
            1200: {
                slidesPerView: 2.5
            }
        }
    });
    
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            closeModal();
        }
    });

    if (document.body.classList.value.indexOf('template-product') != -1)
        updateTables();
   
    if (document.body.classList.value.indexOf('template-collection') != -1) {
        var endlessScroll = new Ajaxinate({
        method: 'scroll', // Change to 'click' if you want a button instead
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        callback: function() {
            initProductSliders();
        }
        });
    }
});

const shoeData = window.shoeData || {};
function updateTables() {

    const region = document.getElementById('countrySelect').value;
    const type = document.getElementById('shoeType').value;

    if (!shoeData[type] || !shoeData[type][region]) {
        return;
    }

    const data = shoeData[type][region];

    document.getElementById('tableTitle').innerText = data.title;

    document.getElementById('shoeHeader').innerHTML = `
        <tr>
            <th>POSA SIZE</th>
            ${data.ysl.map(size => `<td>${size}</td>`).join('')}
        </tr>
    `;

    document.getElementById('shoeBody').innerHTML = `
        <tr>
            <th>${data.label}</th>
            ${data.values.map(size => `<td>${size}</td>`).join('')}
        </tr>
    `;
}

function openModal() {
    // document.getElementById('overlay').classList.add('open');
    document.getElementById('modal').classList.add('open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('search-overlay-active');
}

function closeModal() {
    // document.getElementById('overlay').classList.remove('open');
    document.getElementById('modal').classList.remove('open');
    document.body.classList.remove('search-overlay-active');
    document.body.style.overflow = '';
}

const dropdown = document.querySelector('.eq-product-banner-size');
const selected = dropdown?.querySelector('.eq-product-banner-size__selected');
const value = dropdown?.querySelector('.eq-product-banner-size__value');
const options = dropdown?.querySelectorAll('.eq-product-banner-size__menu li');

selected?.addEventListener('click', () => {
    dropdown?.classList.toggle('active');
});

options?.forEach(option => {
    option.addEventListener('click', () => {

        options?.forEach(item => {
            item?.classList.remove('active');
        });

        option?.classList.add('active');

        value.textContent = option.dataset.value;
        value.style.color = '#111';

        dropdown?.classList.remove('active');
    });
});

document.querySelectorAll('.eq-product-banner__option').forEach(item => {
    item.addEventListener('click', function () {
        window.location.href = this.dataset.productUrl;
    });
});

const country_toggle = document.querySelector('.js-country-toggle');
const country_dropdown = document.querySelector('.country-dropdown');


country_toggle?.addEventListener('click', function (e) {

    e.stopPropagation();
    this.classList.toggle('active');
    country_dropdown?.classList.toggle('active');

});

document.addEventListener('click', function (e) {

    if (
        country_dropdown &&
        !country_dropdown.contains(e.target) &&
        !country_toggle.contains(e.target)
    ) {
        country_dropdown.classList.remove('active');
    }

});
country_dropdown?.addEventListener('wheel', function(e) {
    e.stopImmediatePropagation();
});